import { render, staticRenderFns } from "./MovieHero.vue?vue&type=template&id=5642e5d0&scoped=true&"
import script from "./MovieHero.vue?vue&type=script&lang=js&"
export * from "./MovieHero.vue?vue&type=script&lang=js&"
import style0 from "./MovieHero.vue?vue&type=style&index=0&id=5642e5d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642e5d0",
  null
  
)

export default component.exports